<div [kalLoading]="loading" kalDialogContent>

    <div>
        La suppression de l'avoir {{ invoice.NumFacture }} entraînera l'action suivante :
    </div>

    <div>
        <span class="gup-U-color--green">Génération</span> d'une facture à partir de l'avoir n°{{ invoice.NumFacture }}
    </div>

    <div>
        A quelle date souhaitez-vous que les actions mentionnées ci-dessus soient effectuées ?
    </div>

    <kal-form-field class="without-label">

        <kal-datepicker [formControl]="dateControl"
                        id="activity_delete_credit_dialog_deleting_credit_date">
        </kal-datepicker>

    </kal-form-field>

</div>

<div kalDialogFooter>

    <div class="gup-O-list gup-C-validationArea">

        <div class="gup-O-list__item">

            <kal-button (click)="submit()"
                        [disabled]="loading"
                        id="activity_delete_credit_dialog_submit"
                        kalTheme="primary">
                Valider
            </kal-button>

        </div>

        <div class="gup-O-list__item">

            <kal-button (click)="cancel()"
                        id="activity_delete_credit_dialog_cancel"
                        kalTheme="secondary">
                Annuler
            </kal-button>

        </div>

    </div>

</div>
